export default {
  Cheque: 40,      // Phát hành séc
  CAPayment: 21,   // Phiếu chi
};
